var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.is_nested ? 'form-submission-card-content-child-item' : 'form-submission-card-content-child'},[_c('response-question',{attrs:{"question":_vm.question}}),_vm._v(" "),_c('div',{staticClass:"form-submission-card-content-free-text"},[_vm._v(_vm._s(_vm.answer_computed))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }